import environment from '#/environment/environment';
import {Chain} from 'viem';
import {mainnet} from 'viem/chains';

export const getHttpTransportUrl = (chain: Chain) => {
  if (environment.alchemyHttpsUrl && chain.id !== mainnet.id) {
    return environment.alchemyHttpsUrl;
  }

  return chain.rpcUrls.default.http[0];
};
